import {IEnvironmentModel} from './environment.model';

export const environment: IEnvironmentModel = {
    snackbarDuration: 3000,
    formDebounceTime: 500,
};
